// DashboardViewTabs.jsx — Wave 2A: single consistent view-switch mechanism.
// Replaces the scattered large toggle buttons with one tabbed navigation.
// Semantics preserved: Current | History (+Archive sub-view) | Sent | While Away.
// Keyboard: native tab-like buttons with aria-selected + roving arrow keys.

import React, { useRef } from "react";

const DashboardViewTabs = ({ items, activeId, onChange }) => {
  const listRef = useRef(null);

  const handleKeyDown = (event) => {
    const tabs = Array.from(listRef.current?.querySelectorAll("button:not(:disabled)") || []);
    const index = tabs.indexOf(document.activeElement);
    if (index === -1) return;

    let next = null;
    if (event.key === "ArrowRight") next = tabs[(index + 1) % tabs.length];
    if (event.key === "ArrowLeft") next = tabs[(index - 1 + tabs.length) % tabs.length];
    if (event.key === "Home") next = tabs[0];
    if (event.key === "End") next = tabs[tabs.length - 1];

    if (next) {
      event.preventDefault();
      next.focus();
      next.click();
    }
  };

  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <div className="wvd-tabs" role="tablist" aria-label="Document views" ref={listRef} onKeyDown={handleKeyDown}>
      {items.map(({ id, label, icon: Icon, count, countTone, disabled, title }) => (
        <button
          key={id}
          type="button"
          role="tab"
          className="wvd-tab"
          aria-selected={activeId === id}
          disabled={disabled}
          title={title || undefined}
          onClick={() => !disabled && onChange(id)}
        >
          {Icon ? <Icon size={16} aria-hidden="true" /> : null}
          {label}
          {typeof count === "number" && count > 0 ? (
            <span className={`wvd-tab__count ${countTone ? `wvd-tab__count--${countTone}` : ""}`.trim()}>
              {count}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  );
};

export default DashboardViewTabs;
